export function getKameleoonInfo() {
  if (typeof window === 'undefined') return;
  const experiment = window.Kameleoon?.API?.Experiments?.getActive()?.[0];
  if (!experiment) return;
  const name = experiment?.name;
  const payload = { ab_test_name: name };
  const id = experiment?.id;
  const kameleoonDataJson = localStorage.getItem(`kameleoonExperiment-${id}`);
  if (!kameleoonDataJson) return payload;

  const kameleoonData = JSON.parse(kameleoonDataJson);
  const kameleoonDataValue = kameleoonData.value;
  if (!kameleoonDataValue) return payload;

  const KameleoonVariationId = kameleoonDataValue.split('/')[0];
  if (!KameleoonVariationId) return payload;

  const KameleoonVariationName = experiment.variations.find(
    (variation) => variation.id.toString() === KameleoonVariationId,
  )?.name;

  return {
    abTestName: name,
    abTestVariation: KameleoonVariationName,
  };
}
